import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('ProductFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getNewProduct: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/newproduct");
        },
        getProductDetails: function (id) {
            return $http.get(settings.ApiURL + settings.ProductURL + "/" + id);
        },
        saveProduct: function (product) {
            return $http.put(settings.ApiURL + settings.ProductURL, product);
        },
        saveProductType: function (productType) {
            return $http.put(settings.ApiURL + settings.ProductURL + "/producttypes", productType);
        },
        deleteProduct: function (id) {
            return $http.delete(settings.ApiURL + settings.ProductURL + "/" + id);
        },
        getFilteredProductList: function (filterOptions) {
            return $http.put(settings.ApiURL + settings.ProductURL + "/filter", filterOptions);
        },
        getProductCategoryList: function () {
            return $http.get(settings.ApiURL + settings.ProductCategoriesURL);
        },
        saveProductCategory: function (productCategories) {
            return $http.put(settings.ApiURL + settings.ProductCategoriesURL, productCategories);
        },
        deleteProductCategory: function (id) {
            return $http.delete(settings.ApiURL + settings.ProductCategoriesURL + "/" + id);
        },
        isProductCategoryDeletable: function (id) {
            return $http.get(settings.ApiURL + settings.ProductCategoriesURL + "/deletable/" + id);
        },
        getProductCategoryShapes: function () {
            return $http.get(settings.ApiURL + settings.ProductCategoriesURL + "/shapes");
        },
        getProductDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/dropdown/1");
        },
        getSalesTaxDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/salestax/dropdown");
        },
        getQuantityUnitDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/quantityunit/dropdown");
        },
        getPriceChangeableDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/pricechangeable/dropdown");
        },
        getProductTypeDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/producttype/dropdown");
        },
        getDangerousGoodsDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/dangerousgoods/dropdown");
        },
        saveNewUnit: function (newUnit) {
            return $http.put(settings.ApiURL + settings.ProductURL + "/quantityunit/dropdown", newUnit);
        }
    };
}]);

app.controller('ProductController', ['$q', '$scope', 'ProductFactory', 'CompanyFactory', '$uibModal', '$rootScope', 'settings', "masterFactory",
    function ($q, $scope, ProductFactory, CompanyFactory, $uibModal, $rootScope, settings, masterFactory) {
        $rootScope.pageTitle = "Product";
        $scope.companyDropdown = [];
        $scope.nonPrintCompanies = [];
        $scope.dangerousgoodsDropdown = [];
        $scope.productList = [];
        $scope.productDropdown = [];
        $scope.producttypeDropdown = [];
        $scope.salestaxDropdown = [];
        $scope.submitted = false;
        $scope.quantityunitDropdown = [];
        $scope.pricechangeableDropdown = [];
        $scope.product = {};
        $scope.newproduct = {};
        $scope.ProductCategories = [];
        $scope.error = "";
        $scope.modelState = [];
        $scope.isFormVisible = false;
        $scope.PageSize = 20;
        $scope.TotalCount = null;
        $scope.filterOptions = {
            ProductNumber: null, ProductName: null, ProductGroup: null,
            GridPagerOptions: { PageIndex: 0, PageSize: 20, TotalPages: null }
        };

        var getProductDetails = function (id) {
            ProductFactory.getProductDetails(id).success(function (data) {
                $scope.product = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        };

        var productGridDataSource = {
            store: new DevExpress.data.CustomStore({
                // DataSource Configuration
                key: ["Id"],
                pageSize: $scope.PageSize,
                // Data Access Logic
                load: function (loadOptions) {
                    var d = $.Deferred();
                    var params = {};

                    if (loadOptions != undefined) {
                        $scope.filterOptions.ProductNumber = null;
                        $scope.filterOptions.ProductName = null;
                        $scope.filterOptions.ProductGroup = null;
                        if (loadOptions.filter != undefined) { // accessing grid filter values                         
                            for (var i = 0; i < loadOptions.filter.length; i++) {
                                if (loadOptions.filter[i].length == 3) {
                                    if (loadOptions.filter[i][0] == "ProductNumber") $scope.filterOptions.ProductNumber = loadOptions.filter[i][2];
                                    else if (loadOptions.filter[i][0] == "ShortProductName") $scope.filterOptions.ProductName = loadOptions.filter[i][2];
                                    else if (loadOptions.filter[i][0] == "ProductCategoryId") $scope.filterOptions.ProductGroup = loadOptions.filter[i][2];
                                }
                            }
                        }
                        $scope.filterOptions.GridPagerOptions.PageSize = (IsUndefinedOrNull(loadOptions.take) == true) ? $scope.PageSize : loadOptions.take;
                        $scope.filterOptions.GridPagerOptions.PageIndex = ((IsUndefinedOrNull(loadOptions.take) && IsUndefinedOrNull(loadOptions.skip)) == true) ? 0 : (loadOptions.skip / loadOptions.take);
                    }
                    ProductFactory.getFilteredProductList($scope.filterOptions).success(function (data) {
                        d.resolve(data.ProductListVM, { totalCount: data.TotalCount });
                        $scope.TotalCount = data.TotalCount;
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                    });
                    return d.promise();
                },
                byKey: function (key, extra) {
                },
                update: function (values) {
                }
            })
        };

        // Grid renderers
        $scope.refreshGrid = function (PageIndex) {
            $('#gridProduct').dxDataGrid({
                columns: [
                    { caption: 'Product Number', dataField: 'ProductNumber', cssClass: 'ProductNumber', dataType: 'string', alignment: 'center', width: 150 },
                    {
                        caption: 'Product Name', dataField: 'ShortProductName', cssClass: 'ShortProductName', dataType: 'string', alignment: 'center',
                        cellTemplate: function (container, options) {
                            $('<span />')
                                .text(options.data.ShortProductName)
                                .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    },
                    {
                        caption: 'Product Category', dataField: 'ProductCategoryId', cssClass: 'ProductCategoryId', dataType: 'number', alignment: 'center',
                        lookup: {
                            dataSource: $scope.ProductCategories,
                            displayExpr: 'Name',
                            valueExpr: 'Id'
                        }
                    }
                ],
                contentReadyAction: grdReadyAction,
                dataSource: productGridDataSource,
                filterRow: { visible: true },
                groupPanel: { visible: false },
                noDataText: "No Products Found",
                paging: { pageSize: $scope.PageSize, pageIndex: PageIndex },
                pager: { visible: true, allowedPageSizes: [10, 20, 30], showPageSizeSelector: true },
                rowAlternationEnabled: false,
                selection: { mode: 'single' },
                selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData[0] != null) {
                        getProductDetails(selectedRowsInfo.selectedRowsData[0].Id);
                    }
                    else {
                        $scope.product = angular.copy($scope.newproduct);
                    }

                    $scope.isFormVisible = true;
                    $scope.isDeleteVisible = true;
                    ToggleYellowToGreen();
                    $rootScope.pageTitle = "Product";
                    $scope.newUnit = "";
                    $scope.isNewUnit = false;
                },
                scrolling: { mode: 'standard' },
                showBorders: true,
                showColumnLines: true,
                showRowLines: false,
                sorting: { mode: 'none' }
            });
        };

        // Button click functions and submit form function
        $scope.addNewProduct = function () {
            $rootScope.pageTitle = "New Product";
            $scope.newUnit = "";
            $scope.isNewUnit = false;
            $scope.isFormVisible = true;
            $scope.isDeleteVisible = false;
            $scope.product = angular.copy($scope.newproduct);
            ToggleGreenToYellow();
        };

        $scope.confirmDeleteEntity = function () {
            $('#DeleteModal').modal({ backdrop: 'static' });
        };

        $scope.deleteEntity = function (value) {
            if (value == 0) {
                $('#DeleteModal').modal('hide');
            }
            else if (value == 1) {
                ProductFactory.deleteProduct($scope.product.Id).success(function (data) {
                    var dataGrid = $('#gridProduct').dxDataGrid('instance');
                    dataGrid.refresh();
                    $scope.cancelForm();
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Product successfully' });
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#DeleteModal').modal('hide');
                });
            }
        };

        $scope.cancelForm = function () {
            var dataGrid = $('#gridProduct').dxDataGrid('instance');
            dataGrid.clearSelection();
            $scope.isFormVisible = false;
            $scope.productForm.submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
        };

        $scope.reset = function (type) {
            if (type == 'update') { // get db bankaccount and set to scope.bankaccount.
                getProductDetails($scope.product.Id);
            }
            else {
                angular.copy($scope.newproduct, $scope.product);
            }

            $scope.newUnit = "";
            $scope.isNewUnit = false;
            $scope.productForm.$setPristine();
            $scope.productForm.submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Product details were reset' });
        };

        $scope.submitForm = function () {
            if ($scope.productForm.$valid) {
                $scope.saveProduct();
                $scope.productForm.submitted = false;
            } else {
                $scope.productForm.submitted = true;
            }
        };

        $scope.saveProduct = function () {
            $('#loadingModal').modal({ backdrop: 'static' });
            $scope.closeModelStateErrors();
            ProductFactory.saveProduct($scope.product).success(function (data) {
                var dataGrid = $('#gridProduct').dxDataGrid('instance');
                //$scope.pageSize = dataGrid.pageSize();
                var pageindex = dataGrid.pageIndex();
                var keys = dataGrid.getSelectedRowKeys();
                if ($scope.product.Id <= 0) {
                    $scope.cancelForm();
                    $scope.refreshGrid(pageindex, null);
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Product successfully' });
                }
                else {
                    $scope.refreshGrid(pageindex, keys);
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Product successfully' });
                }
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        // Adding and saving  new Quantity Unit
        $scope.addNewUnit = function () {
            $scope.isNewUnit = true;
            $scope.newUnit = "";
            masterFactory.setFocus('focusNewUnit');
        };

        $scope.saveNewUnit = function () {
            if ($scope.newUnit != "") {
                var flag = false;
                for (var i = 0; i < $scope.quantityunitDropdown.length; i++) {
                    if ($scope.quantityunitDropdown[i].toLowerCase() == $scope.newUnit.toLowerCase()) {
                        flag = true;
                        $scope.newUnit = $scope.quantityunitDropdown[i];
                    }
                }
                if (!flag) $scope.quantityunitDropdown.push($scope.newUnit);
                $scope.product.QuantityUnit = $scope.newUnit;
                $scope.isNewUnit = false;
            }
            else {
                masterFactory.setFocus('focusNewUnit');
            }
        };

        $scope.cancelNewUnit = function () {
            $scope.newUnit = "";
            $scope.isNewUnit = false;
        };

        // New Product type button click function

        $('#productTypeModal').on('hidden.bs.modal', function () {
            $scope.productType = {};
            $scope.modelError = '';
        });

        $scope.addnewProductType = function () {
            $('#productTypeModal').modal({ backdrop: 'static' });
            ProductFactory.saveProductType($scope.productType).success(function (data) {
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Added new Product Type' });
                ProductFactory.getProductTypeDropdown().success(function (data) {
                    $scope.producttypeDropdown = data;
                    $('#productTypeModal').modal('hide');
                }).error(function (data, status) {
                    masterFactory.setError(status, 'Error loading Product Types: ' + data, $scope);
                });
            }).error(function (data) {
                $scope.modelError = data;
            }).finally(function () {

            });
        };

        $scope.closeProductType = function () {
            $scope.productType = null;
            $scope.modelError = '';
            $('#productTypeModal').modal('hide');
        };


        $scope.viewProductCategoriesModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app-legacy/Entities/templates/productCategoriesModal.html',
                controller: 'ProductCategoriesModalController',
                controllerAs: 'modalVm',
                size: 'lg',
                scope: $scope
            });

            modalInstance.result.then(function (message) {
                if (message == 'ok') {
                    ProductFactory.getProductCategoryList().success(function (data) {
                        $scope.ProductCategories = data;
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }),
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Saved Product Categories successfully' });
                }

            }, function () {

            });
        };


        $scope.closeModelAlert = function () {
            $scope.modelError = '';
        };

        // Helping functions and events
        $(window).resize(function () {
            onWindowResize('#gridProduct', settings.GridMarginHeight);
        });

        function grdReadyAction(e) {
            onWindowResize('#gridProduct', settings.GridMarginHeight);
        }

        collapsibleHeaderClickEvent($scope);

        $scope.closeAlert = function () {
            $scope.error = null;
        };

        $scope.closeModelStateErrors = function () {
            $scope.modelState = [];
        };

        $scope.filter = function (input, id) {
            var i = 0, len = input.length;
            for (; i < len; i++) {
                if (+input[i].Id == +id) {
                    return input[i];
                }
            }
            return null;
        };

        $scope.setProductWeightDefaultValue = function (IsEmptyArticle) {
            if (IsEmptyArticle == true && $scope.product.ProductWeight != 0)
                $scope.product.ProductWeight = 0;
        };

        // Initialization - this runs on load
        var init = function () {
            masterFactory.verifyAuthentication();

            $('#loadingModal').modal({ backdrop: 'static' });
            $q.all([
                ProductFactory.getProductCategoryList().success(function (data) {
                    $scope.ProductCategories = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CompanyFactory.getCompanyDropDown(1).success(function (data) {
                    $scope.companyDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CompanyFactory.getNonPrintCompanyList(1).success(function (data) {
                    $scope.nonPrintCompanies = data;
                }).error(function (data) {
                    masterFactory.setError(status, data, $scope);
                }),
                ProductFactory.getProductDropdown().success(function (data) {
                    $scope.productDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                ProductFactory.getSalesTaxDropdown().success(function (data) {
                    $scope.salestaxDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                ProductFactory.getQuantityUnitDropdown().success(function (data) {
                    $scope.quantityunitDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                ProductFactory.getPriceChangeableDropdown().success(function (data) {
                    $scope.pricechangeableDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                ProductFactory.getProductTypeDropdown().success(function (data) {
                    $scope.producttypeDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                ProductFactory.getDangerousGoodsDropdown().success(function (data) {
                    $scope.dangerousgoodsDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                ProductFactory.getNewProduct().success(function (data) {
                    $scope.newproduct = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                })
            ]).then(function () {
                $scope.refreshGrid(0, null);
                $('#loadingModal').modal('hide');
            });
        };

        init();

    }]);

app.controller('ProductCategoriesModalController', ['$scope', '$q', 'ProductFactory', '$uibModalInstance', '$uibModal', 'masterFactory',
    function ($scope, $q, ProductFactory, $uibModalInstance, $uibModal, masterFactory) {
        var modalVm = this;

        init();

        modalVm.addNewProductCategory = function () {

            var newidcount = -1;
            for (var i = 0; i <= modalVm.ProductCategoryList.length - 1; i++) {
                if (modalVm.ProductCategoryList[i].Id <= 0) newidcount--;
            }
            modalVm.NewProductCategory = { Id: newidcount, Name: '', Shape: 0, SetupTime: 0, PumpTime: 0 };
            modalVm.ProductCategoryList.push(modalVm.NewProductCategory);
        };

        modalVm.saveProductCategory = function () {

            if ($scope.productCategoriesForm.$valid) {
                $scope.productCategoriesForm.$submitted = false;
                ProductFactory.saveProductCategory(modalVm.ProductCategoryList).success(function (data) {

                    $uibModalInstance.close('ok');

                    ProductFactory.getProductCategoryList().success(function (data) {
                        $scope.ProductCategories = data;

                        var dataGrid = $('#gridProduct').dxDataGrid('instance');
                        $scope.refreshGrid(dataGrid.pageIndex(), null);
                    });
                    

                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                });
            }
        };


        modalVm.deleteProductCategory = function (item, index) {

            if (item.Id < 0) {
                modalVm.ProductCategoryList.splice(index, 1);
            }
            else {
                ProductFactory.isProductCategoryDeletable(item.Id).success(function (data) {
                    if (data == true) {
                        ProductFactory.deleteProductCategory(item.Id).success(function (data) {
                            modalVm.ProductCategoryList.splice(index, 1);

                        }).error(function (data, status) {
                            masterFactory.setError(status, data, modalVm);
                        });
                    }
                    else {
                        modalVm.ProductCategoryToDelete = { item: item, index: index };
                        modalVm.OpenDialog_ConfirmDeleteProductCategory();
                    }
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                });
            }
        };


        modalVm.OpenDialog_ConfirmDeleteProductCategory = function () {

            var dialog_confirmDeleteProductCategory = $uibModal.open({
                templateUrl: 'app-legacy/Entities/templates/productCategories_DeleteConfirmationModal.html',
                controller: 'ProductCategory_DeleteConfirmationController',
                controllerAs: 'modalVm',
                size: 'md'
            });

            dialog_confirmDeleteProductCategory.result.then(function (confirmDeleteProductCategory) {
                if (confirmDeleteProductCategory) {

                    ProductFactory.deleteProductCategory(modalVm.ProductCategoryToDelete.item.Id).success(function (data) {
                        modalVm.ProductCategoryList.splice(modalVm.ProductCategoryToDelete.index, 1);
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, modalVm);
                    });
                }
            });
        };


        modalVm.selectProductCategory = function (index) {
            modalVm.selectedProductCategoryId = index;
            modalVm.currentProductCategory = modalVm.ProductCategoryList[index];
        };

        modalVm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
                    
            ProductFactory.getProductCategoryList().success(function (data) {
                $scope.ProductCategories = data;
                var dataGrid = $('#gridProduct').dxDataGrid('instance');
                $scope.refreshGrid(dataGrid.pageIndex(), null);
            });
        };

        modalVm.closeAlert = function () {
            modalVm.error = "";
        };

        modalVm.closeModelStateErrors = function () {
            modalVm.modelState = [];
        };

        function init() {

            modalVm.error = "";
            modalVm.modelState = [];
            modalVm.ProductCategoryList = [];
            modalVm.ProductCategoryToDelete = { item: null, index: null };

            $q.all([

                ProductFactory.getProductCategoryList().success(function (data) {
                    modalVm.ProductCategoryList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                }),

                ProductFactory.getProductCategoryShapes().success(function (data) {
                    modalVm.ProductCategoryShapes = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, modalVm);
                })

            ]).then(function () {

                modalVm.selectProductCategory(0);
            });
        };
    }]);


app.controller('ProductCategory_DeleteConfirmationController', ['$scope', '$uibModalInstance', '$uibModal',
    function ($scope, $uibModalInstance, $uibModal) {
        var modalVm = this;

        modalVm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        modalVm.confirmDeleteProductCategory = function () {
            $uibModalInstance.close(true);
        };
    }]);
